export const EquipmentStaffNoteController = {
    index(): void {},
    show(): void {},
};
